// extracted by mini-css-extract-plugin
export var dropContainer = "styles-module__dropContainer___XIHBl";
export var header = "styles-module__header___CM9Au";
export var stepText = "styles-module__stepText___hWVWA";